module.exports = __webpack_public_path__ + "static/media/ProximaNova-Light.eb74a591.woff";